import { headerWithLogoutAndBUFactory } from 'common/components/core/app_bar/HeaderWithLogoutAndBU';

const EntityMgmtHeader = headerWithLogoutAndBUFactory({});

export default EntityMgmtHeader;
